import imageTecnnova from "../images/callsAndProccesses/logo-tecnnova.png"
import imageTecnopar from "../images/callsAndProccesses/logo-tecnoparque.png"
import imagePatente from "../images/callsAndProccesses/logo-patente.png"

export const CallsMessages = {
    call1: {
        imagePath: `${imageTecnnova}`,
        title: "Tecnnova",
        description: "",
        aditionalInfo: "Ruta N"
    },
    call2: {
        imagePath: `${imageTecnopar}`,
        title: "Tecnoparque SENA",
        description: "",
        aditionalInfo: "SENA"
    },
    call3: {
        imagePath: `${imagePatente}`,
        title: "Sacale el jugo a tu patente",
        description: "",
        aditionalInfo: "MinTIC"
    }
} 